import { SVGProps } from 'react';

export const IconUsers = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox='0 0 24 24' {...props}>
      <path
        d='M7.61694 11.9999C9.29281 11.9999 10.6514 10.6414 10.6514 8.9655C10.6514 7.28963 9.29281 5.93106 7.61694 5.93106C5.94106 5.93106 4.58249 7.28963 4.58249 8.9655C4.58249 10.6414 5.94106 11.9999 7.61694 11.9999Z'
        fill='currentColor'
      />
      <path
        d='M11.0728 13.6858C9.88601 13.0832 8.57614 12.8429 7.61692 12.8429C5.73809 12.8429 1.88519 13.9952 1.88519 16.2988V18.0689H8.20695V17.3917C8.20695 16.5909 8.54411 15.788 9.13414 15.1188C9.6049 14.5844 10.2641 14.0883 11.0728 13.6858Z'
        fill='currentColor'
      />
      <path
        d='M15.5402 13.3487C13.3457 13.3487 8.96555 14.704 8.96555 17.3946V19.4175H22.1148V17.3946C22.1148 14.704 17.7347 13.3487 15.5402 13.3487Z'
        fill='currentColor'
      />
      <path
        d='M15.5402 12C17.5885 12 19.2489 10.3395 19.2489 8.29122C19.2489 6.24292 17.5885 4.58245 15.5402 4.58245C13.4919 4.58245 11.8314 6.24292 11.8314 8.29122C11.8314 10.3395 13.4919 12 15.5402 12Z'
        fill='currentColor'
      />
    </svg>
  );
};
